import { Pipe, PipeTransform } from '@angular/core';
import { FormlySelectOption } from '@ngx-formly/core/select';
import { find } from 'lodash';

@Pipe({
  name: 'matchingLabel',
  standalone: true,
})
export class MatchingLabelPipe implements PipeTransform {
  transform(value: unknown, options: FormlySelectOption[]): string {
    const matchingOption = find(options, { value });
    if (!matchingOption) {
      console.warn(
        'Matching option not found for value:',
        value,
        'in options',
        options
      );
    }
    return matchingOption ? matchingOption.label : '';
  }
}
